<div class="flex justify-center items-center h-screen w-full bg-[#505A78]">
  <div class="bg-white w-full h-full block p-1">
    <iframe class="h-full" (load)="iframeLoaded(child)" [hidden]="!sanitizedUrl" frameBorder="0" [src]="sanitizedUrl" #child></iframe>
  </div>
  </div>

